module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "appbind"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAppBatch),
      expression: "isAppBatch"
    }],
    staticClass: "gPageBorder gTopMg",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('p', {
    staticClass: "gCtColor  gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('menu.terManageSub.appList')) + " ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.info.data,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appName",
      "label": _vm.$t('app_appName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appSize",
      "width": "",
      "label": _vm.$t('app_fileSize')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s((scope.row.appSize / 1000000).toFixed(2)) + " MB")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appVersion",
      "width": "",
      "label": _vm.$t('app_version')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "createTime",
      "width": "175",
      "label": _vm.$t('app_ulTime')
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isAppBatch),
      expression: "!isAppBatch"
    }],
    staticStyle: {
      "margin-bottom": "20px",
      "margin-top": "5px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.pushedList = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pusheddvlist')))]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_pushDevice'),
      "size": "large"
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.pushedList),
      callback: function($$v) {
        _vm.pushedList = $$v
      },
      expression: "pushedList"
    }
  }, [_c('div', {
    staticClass: " ",
    attrs: {
      "id": ""
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '10'),
      expression: "info.type === '10'"
    }],
    staticClass: "gSgLeftBtn",
    on: {
      "click": function($event) {
        _vm.allUnbind()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_bcrecov')) + " (" + _vm._s(_vm.sNum) + ")")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '1'),
      expression: "info.type === '1'"
    }],
    on: {
      "click": function($event) {
        _vm.mulDelAppPush()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulUnbind')) + " (" + _vm._s(_vm.sNum) + ")")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    on: {
      "click": function($event) {
        _vm.refreshBind()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.shuaxin')))])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "offset": 16,
      "span": 4
    }
  }, [_c('div', {}, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_adname'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "dpTable",
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "align": "center",
      "label": _vm.$t('app_deviceName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_deviceNo'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pushTime",
      "align": "center",
      "label": _vm.$t('app_pushTime'),
      "width": "175"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.info.type === '10'),
            expression: "info.type === '10'"
          }],
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_recov'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-history"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.dfDelCt,
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.info.type === '1'),
            expression: "info.type === '1'"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.delAppPush(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '10' || (_vm.info.type === '1' && !_vm.isAppBatch)),
      expression: "info.type === '10' || (info.type === '1' && !isAppBatch)"
    }],
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 48px)",
      "height": "100%",
      "margin-bottom": "0px",
      "background": "none",
      "padding": "0 0px 12px 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.fileName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "lcpush"
  }, [_c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.version : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_fileSize')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.size : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_distributor')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.mechanismName : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_ulTime')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.createTime : ''))])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "10px",
      "display": "-webkit-flex"
    }
  }, [_c('div', {
    staticClass: "dt-word-title",
    staticStyle: {
      "display": "inline-block",
      "min-width": "70px"
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '10'),
      expression: "info.type === '10'"
    }]
  }, [_vm._v("launcher" + _vm._s(_vm.$t('app_ss')) + "：")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '1'),
      expression: "info.type === '1'"
    }]
  }, [_vm._v(_vm._s(_vm.$t('app_introl')) + "：")])]), _vm._v(" "), _c('div', {
    staticClass: "dt-word-main",
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "background": "none"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.detail ? _vm.detail.memo : ''))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '13'),
      expression: "info.type === '13'"
    }],
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 48px)",
      "height": "100%",
      "margin-bottom": "0px",
      "background": "none",
      "padding": "0 0px 12px 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.fileName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "lcpush"
  }, [_c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.version : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_filetag')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.data.flag : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_excludeapp')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.data.appPackage : ''))])]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "10px",
      "display": "-webkit-flex"
    }
  }, [_c('div', {
    staticClass: "dt-word-title",
    staticStyle: {
      "display": "inline-block",
      "min-width": "70px"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('app_filestss')) + "：")])]), _vm._v(" "), _c('div', {
    staticClass: "dt-word-main",
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "background": "none"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.detail ? _vm.detail.memo : ''))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '14' || _vm.info.type === '15'),
      expression: "info.type === '14' || info.type === '15'"
    }],
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 48px)",
      "height": "100%",
      "margin-bottom": "0px",
      "background": "none",
      "padding": "0 0px 12px 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.fileName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "lcpush"
  }, [_c('tr', [_c('td', {}, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.version : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_fileSize')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? (_vm.detail.size / 1000000).toFixed(2) : '') + "MB\n              ")])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_distributor')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.mechanismName : ''))])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "lcpush"
  }, [_c('tr', [_c('td', {}, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.risk_desc')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.memo : ''))])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '2' && _vm.detail.fileType === '1'),
      expression: "info.type === '2' && detail.fileType === '1'"
    }],
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 48px)",
      "height": "100%",
      "margin-bottom": "0px",
      "background": "none",
      "padding": "0 0px 12px 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.fileName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "lcpush"
  }, [_c('tr', [_c('td', {}, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.version : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_fileSize')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.size : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_distributor')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.mechanismName : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '2'),
      expression: "info.type === '2'"
    }],
    staticClass: "dt-word-title"
  }, [_vm._v("ota" + _vm._s(_vm.$t('app_type')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.cmType))])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "lcpush"
  }, [_c('tr', [_c('td', {}, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_preversion')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.preVersion : ''))])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '4' || (_vm.info.type === '2' && _vm.detail.fileType === '0')),
      expression: "info.type === '4' || (info.type === '2' && detail.fileType === '0' )"
    }],
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 48px)",
      "height": "100%",
      "margin-bottom": "0px",
      "background": "none",
      "padding": "0 0px 12px 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.fileName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "lcpush"
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.version : ''))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_fileSize')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.size : ''))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_distributor')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.mechanismName : ''))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '4'),
      expression: "info.type === '4'"
    }],
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_fwType')) + "：")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '2'),
      expression: "info.type === '2'"
    }],
    staticClass: "dt-word-title"
  }, [_vm._v("ota" + _vm._s(_vm.$t('app_type')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.cmType))])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '6'),
      expression: "info.type === '6'"
    }],
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 48px)",
      "height": "100%",
      "margin-bottom": "0px",
      "background": "none",
      "padding": "0 0px 12px 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.fileName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "lcpush"
  }, [_c('tr', [_c('td', {}, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_animation') + _vm.$t('app_type')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.adType[_vm.detail.fileType] : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_animation') + _vm.$t('app_size1')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.size : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_playPlace')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.playPlace[_vm.detail.memo] : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '6'),
      expression: "info.type === '6'"
    }],
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_customsTime')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.createTime : ''))])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder gTopMg",
    attrs: {
      "id": ""
    }
  }, [_c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_push')
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.pushQs),
      callback: function($$v) {
        _vm.pushQs = $$v
      },
      expression: "pushQs"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('app_ispushf') + '，' + _vm.fileName) + "？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '1'),
      expression: "info.type === '1'"
    }],
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.check1),
      callback: function($$v) {
        _vm.check1 = $$v
      },
      expression: "check1"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_autoscopen')))]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.check2),
      callback: function($$v) {
        _vm.check2 = $$v
      },
      expression: "check2"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_psscandtip')))])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '2'),
      expression: "info.type === '2'"
    }],
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.check1),
      callback: function($$v) {
        _vm.check1 = $$v
      },
      expression: "check1"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_tipud')))]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.check2),
      callback: function($$v) {
        _vm.check2 = $$v
      },
      expression: "check2"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_tipdown')))])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushQs = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.surePush
    }
  }, [_vm._v(_vm._s(_vm.$t('app_srpush')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_fipush')
    },
    on: {
      "close": _vm.closeImport
    },
    model: {
      value: (_vm.pushImport),
      callback: function($$v) {
        _vm.pushImport = $$v
      },
      expression: "pushImport"
    }
  }, [_c('el-form', {
    ref: "",
    attrs: {
      "model": "",
      "rules": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_ulfile'),
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.importTemplate,
      "on-remove": _vm.handleRemove,
      "before-upload": _vm.srcBefore,
      "on-success": _vm.srcSuccess,
      "on-error": _vm.ulError,
      "file-list": _vm.fileList,
      "auto-upload": true
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-left": "8px",
      "margin-right": "10px"
    },
    attrs: {
      "href": _vm.downTpl
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.import_muban')))])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_deviceNum'),
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n          " + _vm._s(_vm.uldata ? _vm.uldata.terNums : 0 + _vm.$t('app_amechine')) + "\n        ")])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '1'),
      expression: "info.type === '1'"
    }],
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.check1),
      callback: function($$v) {
        _vm.check1 = $$v
      },
      expression: "check1"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_autoscopen')))]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.check2),
      callback: function($$v) {
        _vm.check2 = $$v
      },
      expression: "check2"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_psscandtip')))])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '2'),
      expression: "info.type === '2'"
    }],
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.check1),
      callback: function($$v) {
        _vm.check1 = $$v
      },
      expression: "check1"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_tipud')))]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.check2),
      callback: function($$v) {
        _vm.check2 = $$v
      },
      expression: "check2"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_tipdown')))])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushImport = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "disabled": !_vm.uldata,
      "type": "primary"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v(_vm._s(_vm.$t('app_srpush')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_pushAll')
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.pushAll),
      callback: function($$v) {
        _vm.pushAll = $$v
      },
      expression: "pushAll"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.allMcName))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '1'),
      expression: "info.type === '1'"
    }],
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.check1),
      callback: function($$v) {
        _vm.check1 = $$v
      },
      expression: "check1"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_autoscopen')))]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.check2),
      callback: function($$v) {
        _vm.check2 = $$v
      },
      expression: "check2"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_psscandtip')))])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '2'),
      expression: "info.type === '2'"
    }],
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.check1),
      callback: function($$v) {
        _vm.check1 = $$v
      },
      expression: "check1"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_tipud')))]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.check2),
      callback: function($$v) {
        _vm.check2 = $$v
      },
      expression: "check2"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_tipdown')))])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushAll = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.surePushAll
    }
  }, [_vm._v(_vm._s(_vm.$t('app_srpush')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_srpush')
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.pushAf),
      callback: function($$v) {
        _vm.pushAf = $$v
      },
      expression: "pushAf"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.surePushTip))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushAf = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.coverPush('1')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cvpush')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.coverPush('0')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_skpush')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_pssuccess')
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.pushDone),
      callback: function($$v) {
        _vm.pushDone = $$v
      },
      expression: "pushDone"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('app_isjtoviewtd') + '?') + " ")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushDone = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.jumpNow
    }
  }, [_vm._v(_vm._s(_vm.$t('app_nowjump')))])], 1)]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    on: {
      "click": _vm.multiBind
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulPush')) + " (" + _vm._s(_vm.sNum1) + ")")]), _vm._v(" "), _c('el-button', {
    staticClass: "gSgLeftBtn",
    on: {
      "click": function($event) {
        _vm.pushAll = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_allpush')))]), _vm._v(" "), _c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "disabled": false
    },
    on: {
      "click": function($event) {
        _vm.pushImport = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_fipush')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectStChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_deviceNo') + '/' + _vm.$t('app_deviceName'),
      "icon": "search",
      "on-icon-click": _vm.srch
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srch($event)
      }
    },
    model: {
      value: (_vm.iNo),
      callback: function($$v) {
        _vm.iNo = $$v
      },
      expression: "iNo"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData1,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange1
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_deviceNo'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "align": "center",
      "label": _vm.$t('app_deviceName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.info.type == 14 || _vm.info.type == 15) ? _c('span', [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_on')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 3) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_fault')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_sleep')))]) : _vm._e()], 1) : _c('span', [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 3) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_sleep')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 4) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_btn.lock')))]) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate1(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total1
    },
    on: {
      "current-change": _vm.pageSelect1,
      "size-change": _vm.pageSized1
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cc25156"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/PushHisCm.vue
// module id = 1088
// module chunks = 0